import RMSAddPortfolioContainer from "./RMSAddPortfolioContainer";
import RMSAddPortfolioStore from "./RMSAddPortfolioStore";

export default RMSAddPortfolioStore(RMSAddPortfolioContainer);